import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { forwardRef } from 'react';
import TabsContext from './TabsContext.js';
import { Tab as Tab$2, TabSubLabel, TabLabel } from './Tabs.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Button from '../Button/Button.js';

var _excluded = ["children", "index", "disabled", "subLabel", "lowercased", "displayAsButton"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tab = /*#__PURE__*/forwardRef(function (_ref, tabRef) {
  var children = _ref.children,
    index = _ref.index,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$subLabel = _ref.subLabel,
    subLabel = _ref$subLabel === void 0 ? undefined : _ref$subLabel,
    _ref$lowercased = _ref.lowercased,
    lowercased = _ref$lowercased === void 0 ? false : _ref$lowercased,
    _ref$displayAsButton = _ref.displayAsButton,
    displayAsButton = _ref$displayAsButton === void 0 ? false : _ref$displayAsButton,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(TabsContext),
    selectedIndex = _React$useContext.selectedIndex,
    setSelectedIndex = _React$useContext.setSelectedIndex,
    baseId = _React$useContext.baseId;
  if (!children) {
    return null;
  }
  var selected = index === selectedIndex;
  var id = "".concat(baseId, "-tab-").concat(index);
  var panelId = "".concat(baseId, "-tabpanel-").concat(index);
  var TabLabelType = displayAsButton ? Button : TabLabel;
  var buttonProps = displayAsButton ? {
    variant: selected ? 'primary' : 'ghost',
    className: 'uikit-tab-button'
  } : {};
  return /*#__PURE__*/jsxs(Tab$2, _objectSpread(_objectSpread({}, rest), {}, {
    type: "button",
    role: "tab",
    "aria-controls": panelId,
    "aria-selected": selected,
    tabIndex: selectedIndex === index ? '0' : '-1',
    id: id,
    ref: tabRef,
    onClick: disabled ? null : function () {
      return setSelectedIndex(index);
    },
    disabled: disabled,
    $selected: selected,
    $displayAsButton: displayAsButton,
    children: [/*#__PURE__*/jsx(TabLabelType, _objectSpread(_objectSpread({
      $lowercased: lowercased,
      $selected: selected,
      $disabled: disabled
    }, buttonProps), {}, {
      children: children
    })), subLabel && /*#__PURE__*/jsx(TabSubLabel, {
      className: "uikit-font-body-s",
      $disabled: disabled,
      children: subLabel
    })]
  }));
});
Tab.displayName = 'Tab';
var Tab$1 = Tab;

export { Tab$1 as default };
//# sourceMappingURL=Tab.js.map
